export enum TrendType {
    UNKNOWN,
    UP,
    DOWN,
    NEUTRAL,
}
